import axios from 'axios';

import AuthService from './AuthService';
import { SHORTENER_URL } from './constants';

export default class NeonTo {

  static async url(url: string) {

    const response = await axios.post(SHORTENER_URL ?? '',
      {link: url},
      {
        headers: {
        'Authorization': AuthService.getToken(),
      }}
    );

    return response.status === 201
      ? response.data.data.url
      : url;
  }
}
